<template>
  <div>
    <b-modal v-if="!modaladd" id="modal-ajout" hide-footer centered title="Ajouter Utilisateur ">
      <form @submit="formSubmit">
        <div class="pl-lg-4">
          <div class="pl-lg-4">
            <div class="row">
              <div class="col-lg-12">
                <b-form-group id="input-group-1" label="Nom et Prénom" label-for="input-1">
                  <b-form-input
                    label="Nom et Prénom"
                    placeholder="Nom et Prénom"
                    input-classes="form-control-alternative"
                    v-model="model.name"
                    required
                  />
                </b-form-group>
              </div>

              <div class="col-lg-12">
                <b-form-group id="input-group-1" label="Email" label-for="input-1">
                  <b-form-input
                    label="Email"
                    placeholder="jesse@example.com"
                    input-classes="form-control-alternative"
                    v-model="model.email"
                    required
                  />
                </b-form-group>
              </div>
              <div class="col-lg-12">
                <b-form-group id="input-group-1" label="Mot de passe" label-for="input-1">
                  <b-form-input
                    label="Mot de passe"
                    placeholder="Mot de passe"
                    input-classes="form-control-alternative"
                    v-model="model.password"
                    required
                  />
                </b-form-group>
              </div>
              <div class="col-lg-12">
                <b-form-group id="input-group-1" label="Numero Tel" label-for="input-1">
                  <b-form-input
                    label="Numero Tel"
                    placeholder="Numero"
                    input-classes="form-control-alternative"
                    v-model="model.phonenumber"
                    required
                  />
                </b-form-group>
              </div>
            </div>
            <!--  <div class="row">
       
            </div>-->
          </div>
        </div>

        <hr class="my-4" />
        <!-- Description -->
        <center>
          <b-btn type="submit" style="background-color:#000; width: 150px; height:50px;color:#fff">Ajouter</b-btn>
        </center>
      </form>
    </b-modal>
  </div>
</template>
<script>
import { setToken, post } from "@/mixins/api";

export default {
  name: "ModalAjoutUser",
  data() {
    return {
      alert: false,
      modaladd: false,
      dangeradd: false,
      model: {
        name: "",
        email: "",
        password: "",
        phonenumber: ""
      },
      currentPage: 1,
      standAlonePages: {},
      canLoadMore: true,
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
    };
  },

  methods: {
    formSubmit(e) {
      e.preventDefault();
      //let currentObj = this;
      post("signup", this.model).then(resp => {
        this.data = resp.data.data;
        this.$emit("usersadd", this.data, (this.modaladd = false));
      });

      this.modaladd = true;

      e.target.reset();
    }
  },
  mounted() {
    setToken(this.userToken);
    //this.loadData();
  }
};
</script>
                        